interface CrearPayloadCorreccionVozParams {
  usuarioId: string
  terminoIncorrecto: string
  terminoCorrecto: string
}

export function crearPayloadCorreccionVoz(params: CrearPayloadCorreccionVozParams): Record<string, unknown> {
  return {
    user_id: params.usuarioId,
    wrong_term: params.terminoIncorrecto.toLowerCase().trim(),
    correct_term: params.terminoCorrecto.trim(),
  }
}
